<div class="content-insights">
  <div class="wrapper-boxes">
    <div class="wrapper-box-insight" (click)="clickOnCard.emit(InsightsDetailsTypeEnums.followers)">
      <div class="wrapper-icon purple">
        <img src="./assets/icons/insights/icon-insights-followers.svg" alt="">
      </div>
      <span class="value">{{insightsOverview?.total_followers | number}}</span>
      <span class="label">{{'INSIGHTS.total_followers' | translate}}</span>
    </div>
    <div class="wrapper-box-insight" (click)="clickOnCard.emit(InsightsDetailsTypeEnums.likes)">
      <div class="wrapper-icon blue">
        <img src="./assets/icons/insights/icon-insights-likes.svg" alt="">
      </div>
      <span class="value">{{insightsOverview?.total_lyst_likes | number}}</span>
      <span class="label">{{'INSIGHTS.total_list_likes' | translate}}</span>
    </div>
  </div>
  <div class="wrapper-boxes">
    <div class="wrapper-box-insight" (click)="clickOnCard.emit(InsightsDetailsTypeEnums.views)">
      <div class="wrapper-icon orange">
        <img src="./assets/icons/insights/icon-insights-list-views.svg" alt="">
      </div>
      <span class="value">{{insightsOverview?.total_lyst_views | number}}</span>
      <span class="label">{{'INSIGHTS.total_list_views' | translate}}</span>
    </div>
    <div class="wrapper-box-insight" (click)="clickOnCard.emit(InsightsDetailsTypeEnums.shares)">
      <div class="wrapper-icon blue-light">
        <img src="./assets/icons/insights/icon-insights-list-shares.svg" alt="">
      </div>
      <span class="value">{{insightsOverview?.total_lyst_shares | number}}</span>
      <span class="label">{{'INSIGHTS.total_list_shares' | translate}}</span>
    </div>
  </div>
  <div class="header-lists-insights">
    <span> {{'NEW_TEXT.content_you_created' | translate}}</span>
    <button type="submit" class="custom-btn custom-btn--gray" (click)="clickOnViewAllBtn.emit()"><span> {{'NEW_TEXT.view_all' | translate}}</span></button>
  </div>
  <div class="content-slide-list-insights">
    <div class="grid">
      <div *ngFor="let list of insightsLists" class="grid__s-4" (click)="clickOnList.emit(list.id)">
        <div class="wrapper-list-insights">
          <div class="image-insights">
            <img [src]="list?.lyst_image_url !== null ? list?.lyst_image_url  : 'assets/images/no-image.png'" alt="">
          </div>
          <span class="name-list-insights">{{list | matchLocale}}</span>
          <p>{{list?.favorite_users_count}} <span>{{list?.favorite_users_count === 1 ? ('LISTS.like' | translate) : ('LIST_SINGLE_PAGE.likes' | translate)}}</span></p>
          <p>{{list?.views_count}} <span>{{list?.views_count === 1 ? ('LISTS.view' | translate) : ('INSIGHTS.views' | translate)}}</span></p>
          <p>{{list?.shares_count}} <span>{{list?.shares_count === 1 ? ('GENERAL.share' | translate) : ('INSIGHTS.shares' | translate)}}</span></p>
        </div>
      </div>
    </div>
  </div>
</div>
